export const notificationConstants = {
    SUCCESS: 'notify-success',
    INFO: 'notify-info',
    WARNING: 'notify-warning',
    DANGER: 'notify-danger',
    CLEAR: 'NOTIFICATION_CLEAR'
};

